import { useCurrentConversationIdValue } from 'hooks/business/conversation';
import { useConversationOfId } from 'hooks/business/conversationsHooks/useConversationOfId';
import { isNil } from 'lodash-es';
import { useEffect, useMemo } from 'react';
import { isDemoChannel } from 'services/channels/demo';

const getCacheKey = (conversatoinId: Conversation.Conversation['conversationId']) =>
  `@fett-demo-conv-readed_${conversatoinId}`;

/**
 * 演示模式下已读数需要在本地进行伪处理，针对demoOrg及Demo channel
 * PS：不能影响正常渠道及org
 * @param conversatoinId
 * @returns
 */
const useDemoUnreadCount = (conversatoinId: Conversation.Conversation['conversationId']) => {
  const conversation = useConversationOfId(conversatoinId!);
  const currentConversationId = useCurrentConversationIdValue();
  const isCurrenctConversation = conversatoinId && conversatoinId === currentConversationId;
  const unreadCountRaw = conversation?.unreadCount || 0;
  //   const initialUnreadCount = useRef<number>(unreadCount);
  const cacheKey = getCacheKey(conversatoinId);
  useEffect(() => {
    const cache = sessionStorage.getItem(cacheKey);
    if (cache === '0') {
      return;
    }
    if (isNil(cache) && unreadCountRaw > 0) {
      sessionStorage.setItem(cacheKey, `${unreadCountRaw}`);
      return;
    }
    if (isCurrenctConversation) {
      sessionStorage.setItem(cacheKey, '0');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unreadCountRaw, isCurrenctConversation]);
  const count = useMemo(() => {
    if (isCurrenctConversation) {
      return 0;
    }
    if (conversatoinId) {
      // eslint-disable-next-line no-bitwise
      return sessionStorage.getItem(cacheKey) === '0' ? 0 : unreadCountRaw;
    }
    return unreadCountRaw;
  }, [unreadCountRaw, isCurrenctConversation, conversatoinId, cacheKey]);

  return count;
};

const useUnreadCount = (conversatoinId: Conversation.Conversation['conversationId']) => {
  return useConversationOfId(conversatoinId)?.unreadCount || 0;
};

const useDemoCompatUnreadCount = isDemoChannel ? useDemoUnreadCount : useUnreadCount;
export default useDemoCompatUnreadCount;
